// extracted by mini-css-extract-plugin
module.exports = {"simplified-banner":"_93444fe79c--simplified-banner--35Xjz","no-banner":"_93444fe79c--no-banner--1gcCj"};